import { Component, OnInit } from '@angular/core';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { PsrService } from './psr.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-payment-summary-report',
  templateUrl: './payment-summary-report.component.html',
  styleUrls: ['./payment-summary-report.component.scss']
})
export class PaymentSummaryReportComponent implements OnInit {

  public listData = [];
  public listLength = 0;
  private currentFilters;
  public filterNumber: number = 0;
  exportData = [];
  public loading = {
    init: false,
    more: false,
    export: false,
    error: false,
  };
  private listSub: Subscription;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  displayedColumns: string[] = ['settlement_date', 'handling_fee', 'vat', 'withholding_tax',  'net_withholding_tax'];

  constructor (
    public media: MediaObserver,
    public psrService: PsrService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public helper: HelperService
  ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.listSub = this.psrService.generate(this.currentFilters).pipe(
      finalize(() => {
        this.listSub.unsubscribe();
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'success') && (_.get(res, 'success.count') > 0)) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.get(res, 'count');
          this.helper.reportGenerated();
          //REDIRECT TO DOWNLOAD MANAGER
        } else {
          this.listData = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      });
  }

  generateReport(selectedFilters) {
    this.currentFilters.filter.start_date = moment(_.get(selectedFilters, 'settlement_start_date')).format("YYYY-MM-DD");
    this.currentFilters.filter.end_date = moment(_.get(selectedFilters, 'settlement_end_date')).format("YYYY-MM-DD");
    this.currentFilters.filter.chain_id = _.get(selectedFilters, 'chain.id') || 0;
    this.currentFilters.filter.island_group_id = this.helper.reportFilterGet( _.get(selectedFilters, 'island_group'), [0]);
    this.currentFilters.filter.region_id = this.helper.reportFilterGet(_.get(selectedFilters, 'region'), [0]);
    this.currentFilters.filter.province_id = this.helper.reportFilterGet(_.get(selectedFilters, 'province'), [0]);
    this.currentFilters.filter.city_id = this.helper.reportFilterGet(_.get(selectedFilters, 'city'), [0]);
    this.currentFilters.filter.campaign_id = this.helper.reportFilterGet(_.get(selectedFilters, 'campaign'), [0]);
    this.currentFilters.filter.distribution_id = this.helper.reportFilterGet(_.get(selectedFilters, 'distribution'), [0]);
    this.currentFilters.filter.category_id = this.helper.reportFilterGet(_.get(selectedFilters, 'category'), [0]);
    this.currentFilters.filter.brand_id = this.helper.reportFilterGet(_.get(selectedFilters, 'brand'), [0]);
    this.currentFilters.filter.product_id = this.helper.reportFilterGet(_.get(selectedFilters, 'item'), [0]);
    this.refresh();
  }

  refresh() {
    this.listData = [];
    this.listLength = 0;
    this.getListData();
  }
}

const INITIAL_OPTIONS = {
  module_code: "PTSMR",
  file_code: null,
  filter:{
    start_date: "",
    end_date: "",
    chain_id: 0,
    island_group_id: [0],
    region_id: [0],
    province_id: [0],
    city_id: [0],
    campaign_id: [0],
    distribution_id: [0],
    category_id: [0],
    brand_id: [0],
    product_id: [0]
  }
}